import React from "react"
import { StaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

const Indecision = () => (
  <StaticQuery
    query={graphql`
      query {
        app: file(relativePath: { eq: "photos/Indecision.1.jpg" }) {
          childImageSharp {
            fluid(maxWidth: 700) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    `}
    render={data => <Img fluid={data.app.childImageSharp.fluid} />}
  />
)

export default Indecision
